import { render } from "./HeaderLogoView.vue?vue&type=template&id=5a0fa007&scoped=true"
const script = {}

import "./HeaderLogoView.vue?vue&type=style&index=0&id=5a0fa007&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0fa007"]])

export default __exports__